import { useEffect, useState } from 'react';
import { SectionWrapper } from '../../../../components/ui/SectionWrapper';
import { useLanguage } from '../../../../context/LanguageContext';
import { Talk } from '../../../../models/talk.interface';
import { talksService } from '../../../../services/talks.service';

const INITIAL_COUNT = 5;

export function TalksSection() {
    const { lang, t } = useLanguage();
    const [talks, setTalks] = useState<Talk[]>([]);
    const [showAll, setShowAll] = useState(false);

    useEffect(() => {
        setTalks(talksService.getTalks());
    }, []);

    const visible = showAll ? talks : talks.slice(0, INITIAL_COUNT);

    return (
        <SectionWrapper id="talks" title={t('section.talks')} alternate>
            <div className="space-y-3">
                {visible.map(talk => (
                    <div key={talk.id} className="flex items-start gap-3 p-3 rounded-lg hover:bg-white dark:hover:bg-slate-800 transition-colors">
                        <span className="shrink-0 text-sm font-mono font-medium text-blue-600 dark:text-blue-400 w-12 pt-0.5">
                            {talk.year}
                        </span>
                        <div>
                            <p className="font-medium text-slate-900 dark:text-white">
                                {talk.title[lang]}
                            </p>
                            <p className="text-sm text-slate-500 dark:text-slate-400">
                                {talk.event}
                                {talk.representing && ` · ${lang === 'en' ? 'rep.' : 'rep.'} ${talk.representing}`}
                            </p>
                        </div>
                    </div>
                ))}
            </div>

            {talks.length > INITIAL_COUNT && (
                <button
                    onClick={() => setShowAll(!showAll)}
                    className="mt-6 text-sm font-medium text-blue-600 dark:text-blue-400 hover:text-blue-700 dark:hover:text-blue-300 transition-colors"
                >
                    {showAll ? t('label.showLess') : t('label.showAll')} ({talks.length})
                </button>
            )}
        </SectionWrapper>
    );
}
